/**
 * WooCommerce Shop Admin
 *
 * Base wp-admin URL for the WooCommerce shop (agile-assets.ai), used to
 * deep-link from a package's WC-sync state to the underlying WC product
 * for review/editing/publishing by Kristin.
 */
export const WC_SHOP_ADMIN_URL = 'https://agile-assets.ai/wp-admin';

/**
 * Kristin/Mahmud 2026-11-03: the in-app Shop offers MONTHLY only (no Monthly/Yearly toggle, no yearly
 * options selectable or addable). Flip to true to bring yearly back. Owned-state display of an existing
 * yearly plan/add-on and the Billing "switch to yearly" flow are not affected.
 */
export const SHOP_YEARLY_ENABLED = false;

/** Public storefront where users upgrade their plan / buy add-ons. */
export const SHOP_URL = 'https://agile-assets.ai/shop/';

/**
 * Build the wp-admin "Edit Product" URL for a package's linked WC product.
 */
export const getWcProductEditUrl = (wcProductId: number): string =>
  `${WC_SHOP_ADMIN_URL}/post.php?post=${wcProductId}&action=edit`;

/** Shop account page where customers update their payment method (WooCommerce My Account endpoint). */
export const SHOP_PAYMENT_METHODS_URL = 'https://agile-assets.ai/my-account/payment-methods/';

/** Terms / house rules (same link the registration page uses). */
export const TERMS_URL = 'https://agile-assets.ai/house-rules/';

/** Shop terms and conditions: the contract the Early Supporter purchase is made under (ES review step only). */
export const SHOP_TERMS_URL = 'https://agile-assets.ai/terms-conditions/';
